// extracted by mini-css-extract-plugin
module.exports = {"root":"Foreigners-module__root___2j4ow","image":"Foreigners-module__image___15rOx"};